import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";

import { ThemeProvider } from "@material-ui/core/styles";
import theme from "./theme/theme";
import App from "./components/App";
import rootReducer from "./reducers";
import thunk from "redux-thunk";
//import { SnackbarProvider } from "notistack";
import { SetupServiceNetwork } from "./apis/siar";

//import * as serviceWorker from "./serviceWorker";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);
SetupServiceNetwork(store);

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      {/* <SnackbarProvider
        maxSnack={3}
        autoHideDuration={3000}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      > */}
      {/* <React.StrictMode> */}
      <App />
      {/* </React.StrictMode> */}
      {/* </SnackbarProvider> */}
    </ThemeProvider>
  </Provider>,
  document.querySelector("#root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
///serviceWorker.register();
